console.log("Category Knowledge Loaded");

const CATEGORY_KNOWLEDGE = {

    "bulb camera": {

        summary:
        "Bulb Cameras are smart Wi-Fi CCTV cameras that fit into a standard E27 bulb holder. They provide 360° surveillance, remote monitoring, motion detection, night vision, and two-way communication. They are ideal for users looking for an easy-to-install indoor security solution.",

        features: [

            "360° panoramic view",

            "HD video recording",

            "Wi-Fi connectivity",

            "Mobile app control",

            "Motion detection",

            "Night vision",

            "Two-way audio",

            "MicroSD card recording",

            "Easy bulb socket installation"

        ],

        bestFor: [

            "Homes",

            "Apartments",

            "Bedrooms",

            "Living Rooms",

            "Kids Room",

            "Elderly Monitoring",

            "Pet Monitoring"

        ]

    },

    "fingerprint lock": {

        summary:
        "Fingerprint Locks provide keyless access using biometric fingerprint recognition. They improve security while eliminating the need for physical keys.",

        features: [

            "Fingerprint Unlock",

            "Keyless Access",

            "Fast Recognition",

            "Rechargeable Battery",

            "Multiple Fingerprints",

            "Strong Metal Body"

        ],

        bestFor: [

            "Main Doors",

            "Office Cabinets",

            "Drawers",

            "Gym Lockers",

            "Suitcases",

            "Warehouses"

        ]

    },

    "gps tracker": {

        summary:
        "GPS Trackers allow you to monitor the live location of vehicles, family members, pets, and valuable assets in real time using a mobile application.",

        features: [

            "Real-time Tracking",

            "Live Map",

            "Location History",

            "Geo-fencing",

            "Mobile Alerts",

            "Long Battery Backup"

        ],

        bestFor: [

            "Cars",

            "Bikes",

            "School Children",

            "Fleet Management",

            "Pets",

            "Senior Citizens"

        ]

    },

    "smart bulb": {

        summary:
        "Smart Bulbs allow you to control lighting using a smartphone or voice assistant. They support brightness adjustment, color control, scheduling, and automation.",

        features: [

            "Wi-Fi Control",

            "Voice Assistant Support",

            "RGB Colors",

            "Brightness Control",

            "Scheduling",

            "Energy Efficient"

        ],

        bestFor: [

            "Homes",

            "Bedrooms",

            "Living Rooms",

            "Restaurants",

            "Hotels",

            "Decoration"

        ]

    }

};

function getCategoryKnowledge(category){

    return CATEGORY_KNOWLEDGE[category] || null;

}